import { Observable } from 'rxjs';
import httpService from './httpService';

class HelpService {
  private readonly apiBase;

  constructor() {
    const { __environment__ } = window as any;
    const lookupUrl = __environment__.REACT_APP_LOOKUP_API_URL.trim();
    const idx = lookupUrl.lastIndexOf('/');
    this.apiBase = lookupUrl.substring(0, idx);
  }

  public healthCheck(): Observable<any> {
    const url = `${this.apiBase}/health-check`;
    return httpService.getJSON(url);
  }

  public appReady(): Observable<any> {
    const url = `${this.apiBase}/app-ready`;
    return httpService.getJSON(url);
  }
}

const healthService = new HelpService();

export default healthService;
